import { useGridEvent } from 'components/shared/data/DataGrid/hooks';
import { CountSelectedProps } from 'components/shared/data/DataGrid/StatusPanel/CountSelected/CountSelected.types';
import { useTranslator } from 'components/shared/hooks';
import React, { ReactElement, useState } from 'react';

export const CountSelected = ({ api, title }: CountSelectedProps): ReactElement => {
  const [count, setCount] = useState(api.getSelectedRows().length);
  const trans = useTranslator();

  useGridEvent(api, 'selectionChanged', () => {
    setCount(api.getSelectedRows().length);
  });

  return (
    <div className="ag-name-value">{count === 0 ? '' : trans(title || 'COMMON.SELECTED_N_RESULTS', { count })}</div>
  );
};
